const initialState = {
  services: [],
  loading: false,
};

const serviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SERVICES_LOADED":
      state = {
        loading: false,
        services: action.payload.services,
      };
      break;
    case "SERVICES_LOADING":
      state = {
        loading: true,
        services: [],
      };
      break;
    default:
      break;
  }
  return state;
};

export default serviceReducer;






// WEBPACK FOOTER //
// ./src/reducers/serviceReducer.js